module.exports = __webpack_public_path__ + "static/media/icon-filled-active-topics.32b7547e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-filled-active-topics.svg
// module id = 1900
// module chunks = 0